import { render, staticRenderFns } from "./ConsolidationHead.vue?vue&type=template&id=efce9ac6&scoped=true"
import script from "./ConsolidationHead.vue?vue&type=script&lang=js"
export * from "./ConsolidationHead.vue?vue&type=script&lang=js"
import style0 from "./ConsolidationHead.vue?vue&type=style&index=0&id=efce9ac6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efce9ac6",
  null
  
)

export default component.exports